// WALLET
import ManageWallet from "../pages/products/wallet/ManageWallet";
import NewWallet from "../pages/products/wallet/NewWallet";
import ViewWallet from "../pages/products/wallet/ViewWallet";
import ManageWalletAcc from "../pages/customer/accounts/wallet/ManageWalletAcc";
import NewWalletAccount from "../pages/customer/accounts/wallet/NewWalletAccount";
import DetailWalletAccount from "../pages/customer/accounts/wallet/DetailWalletAccount";
import EditWalletAccount from "../pages/customer/accounts/wallet/EditWalletAccount";
import WalletAccountMainActionPage from "../pages/customer/accounts/wallet/actions/WalletAccountMainActionPage";
import DetailSubWallet from "../pages/customer/accounts/wallet/tabs/DetailSubWallet";
import SubWalletAccountMainActionPage from "../pages/customer/accounts/wallet/actions/SubWalletAccountMainActionPage";

export default [
  // Wallet Product
  {
    path: "/wallet-product",
    component: ManageWallet,
    isProtected: true,
  },
  {
    path: "/edit-wallet",
    component: NewWallet,
    isProtected: true,
  },
  {
    path: "/add-wallet",
    component: NewWallet,
    isProtected: true,
  },
  {
    path: "/view-wallet",
    component: ViewWallet,
    isProtected: true,
  },
  // Wallet Account

  {
    path: "/wallet-account",
    component: ManageWalletAcc,
    isProtected: true,
  },

  {
    path: "/new-wallet-account",
    component: NewWalletAccount,
    isProtected: true,
  },
  {
    path: "/edit-wallet-account",
    component: EditWalletAccount,
    isProtected: true,
  },
  {
    path: "/detail-wallet-account",
    component: DetailWalletAccount,
    isProtected: true,
  },
  {
    path: "/wallet-account-action",
    component: WalletAccountMainActionPage,
    isProtected: true,
  },
  {
    path: "/sub-wallet-account-action",
    component: SubWalletAccountMainActionPage,
    isProtected: true,
  },
  {
    path: "/detail-sub-wallet",
    component: DetailSubWallet,
    isProtected: true,
  },
  {
    path: "/sub-wallet-account-action",
    // component: GroupSavingsJournalEntries,
    isProtected: true,
  },
];
